import React, { useEffect, useRef, useState } from "react"
import { BlackPearlTemplate, ISignatureComponent } from "@blackpearlmail/cerberus"
import { HexColorPicker } from "react-colorful"
import { InputText } from "../input-text/input-text"
import { useTracking } from "react-tracking"
import "./style.scss"

export const ColorPicker = (props: any) => {
    const { updateTemplate, template } = props
    const signature = (template as BlackPearlTemplate).components.find(
        (x) => x.type === "SignatureComponent"
    ) as ISignatureComponent
    const [color, setColor] = useState(signature.fontPrimaryColour)
    const [tempColor, setTempColor] = useState(signature.fontPrimaryColour)
    const [picker, togglePicker] = useState(false)
    const pickerRef = useRef() as React.MutableRefObject<HTMLDivElement>
    const swatchRef = useRef() as React.MutableRefObject<HTMLDivElement>
    const { trackEvent } = useTracking()

    useWatchOutside(pickerRef, swatchRef, togglePicker, picker)

    const track = (trackingValue: string) => {
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click input field",
            label: `${trackingValue}`,
        })
    }

    function handleColor(newColor: string) {
        // Only accept chars a-f and all numbers
        if (/^#([a-f0-9]){0,6}$/i.test(newColor)) {
            setColor(newColor)
        }
        // Only update the swatch and template if the hex is valid
        if (/^#([0-9a-f]{3}){1,2}$/i.test(newColor)) {
            const newTemplate = {
                ...template,
                components: (template as BlackPearlTemplate).components.map((component) => {
                    if (component.type === "SignatureComponent") {
                        return {
                            ...component,
                            ...{ fontPrimaryColour: newColor },
                            ...{ socialMedia: { ...signature.socialMedia, color: newColor } },
                        } as ISignatureComponent
                    }
                    return component
                }),
            }
            setTempColor(newColor)
            updateTemplate(newTemplate)
        }
    }

    return (
        <div className="pkr">
            <div data-testid="pkr" className={`pkr-selector ${picker ? "active" : "hidden"}`} ref={pickerRef}>
                <HexColorPicker color={color} onChange={handleColor} style={{ height: "150px" }} />
            </div>
            <div className="pkr-input">
                <InputText
                    track={false}
                    id="color"
                    className="brand-item"
                    placeholder="#5E8598"
                    value={color.startsWith("#") ? color : `#${color}`}
                    maxLength={7}
                    onFocus={() => track("color manual")}
                    onChange={(e) => handleColor(e.target.value)}
                />
                <div className="swatch">
                    <div
                        data-testid="swatch"
                        ref={swatchRef}
                        style={{
                            backgroundColor: tempColor,
                        }}
                        onClick={() => {
                            if (!picker) {
                                track("color picker")
                            }
                            togglePicker(!picker)
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

const useWatchOutside = (
    pickerRef: React.MutableRefObject<HTMLDivElement>,
    swatchRef: React.MutableRefObject<HTMLDivElement>,
    togglePicker: { (value: React.SetStateAction<boolean>): void; (arg0: boolean): void },
    picker: boolean
) => {
    useEffect(() => {
        const handleClickOutside = (event: { target: any }) => {
            if (
                pickerRef.current &&
                !pickerRef.current.contains(event.target) &&
                picker &&
                !swatchRef.current.contains(event.target)
            ) {
                togglePicker(!picker)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [pickerRef, picker])

    return null
}
